import { all } from 'redux-saga/effects';
import chartSaga from '../../charting/redux/saga';

export function* rootSaga() {
   yield all([chartSaga()]);
}
